import { API } from '../utils/amplifyApi';
import { UpdateUserData, User, UserInterface } from '../types/users';
const initIot = async () => {
    await API.get('users', '/initIot', {});
};
const getUser = async (userId: string) => {
    const user: User = await API.get('users', `/users/${userId}`, {});
    return user;
};
const getUsers = async () => {
    const users: User[] = await API.get('users', '/users', {});
    return users;
};
const updateUser = async (userId: string, updateData: UpdateUserData) => {
    const updatedUser: UserInterface = await API.put('users', `/users/${userId}`, {
        body: updateData
    });
    return updatedUser;
};
const updateUserUsedCoupons = async (userId: string, data: any) => {
    const updatedUser: UserInterface = await API.put('users', `/users/addusedcoupon/${userId}`, {
        body: data
    });
    return updatedUser;
};
export const checkForDuplicateRegistrations = async (number: string, email: string) => {
    const verdict: any = await API.post('users', `/users/checkforduplicates`, {
        body: {
            'number': number,
            'email': email
        }
    });
    return verdict;
};
export const checkForDuplicatePhoneNumber = async (number: string, email: string) => {
    const verdict: any = await API.post('users', `/users/checkforduplicatephonenumber`, {
        body: {
            'number': number,
            'email': email
        }
    });
    return verdict;
};
export const updateLastUsedFrontend = async (email: string) => {
    await API.post('users', `/users/updatelastusedfrontend`, {
        body: {
            'email': email,
            // brändi hostnamesta — ohjaa mm. salasananpalautusmailin templaten ja paluulinkin
            'frontend': window.location.hostname.includes('leea') ? 'leea' : 'fiksumyynti'
        }
    });
};
export const notifyAdminLoginFail = async (email: string, phoneNumber: string) => {
    try {
        await API.post('users', `/users/notifyadminloginfail`, {
            body: {
                email,
                phoneNumber,
                platform: 'leea'
            }
        });
    }
    catch (error) {
        // Intentionally left empty
    }
};
export const validateEmail = async (email: string): Promise<boolean> => {
    try {
        const response: any = await API.post('users', `/users/validateemail`, {
            body: {
                email,
            }
        });
        const verdict = JSON.parse(response.body);
        if (verdict && typeof verdict.isValid == 'boolean') {
            return verdict.isValid;
        }
        else {
            console.error('Unexpected response format:', verdict);
            return false;
        }
    }
    catch (error) {
        console.error('Error during email validation:', error);
        return false;
    }
};
export default {
    initIot,
    getUser,
    getUsers,
    updateUser,
    checkForDuplicateRegistrations,
    updateUserUsedCoupons,
    updateLastUsedFrontend,
    notifyAdminLoginFail
};
